<template>
  <div v-if="store.state.showSwitchAccount" class="h-full w-full relative flex items-center justify-center">
    <div v-if="store.state.showSwitchAccount" class="bg-black opacity-50 absolute top-0 bottom-0 left-0 right-0" @click="store.state.showSwitchAccount = false"></div>
    <div v-if="store.state.showSwitchAccount" class="bg-background h-3/5 w-11/12 rounded-3xl flex flex-col gap-4 p-4 max-w-[500px] z-10">

      <div class="flex flex-col items-center gap-2">
        <div class="h-20 w-20"><img class="w-full h-full rounded-full border-2" :src="users.current[0].photo" alt=""></div>
        <div class="flex flex-col gap-0 justify-center items-center col-span-5">
          <div class="overflow-hidden text-ellipsis whitespace-nowrap text-body_lg_semibold">
            {{ users.current[0].name }}
          </div>
          <div class="text-body_md_regular">
            {{ users.current[0].schoolName }}
          </div>
        </div>
        <div class="h-12 w-full flex justify-center items-center rounded-full border-2 border-primary text-label_lg_medium text-primary cursor-pointer" @click="logout" v-if="!store.state.isLoading">{{ $t('Keluar') }}</div>
        <div class="h-12 w-full flex justify-center items-center rounded-full border-2 border-primary text-label_lg_medium text-primary cursor-pointer" v-else>
          <loading class="h-6 w-6 text-primary" />
        </div>
      </div>

      <div class="flex flex-col gap-2 h-full" :class="users.all.length ? 'relative' : ''">
        <div v-if="users.all.length" class="text-subhead_lg_semibold">{{$t('Akun lain')}}</div>
          
        <div class="overflow-y-auto top-8 bottom-2 right-0 left-0 scroll-hidden flex flex-col gap-2" :class="users.all.length ? 'absolute' : ''">
            <div v-for="user in users.all" class="grid grid-cols-5 items-center gap-2 p-2 cursor-pointer h-16 border-2 border-gray-200 rounded-xl" @click="store.dispatch('auth/switchAccount', user)">
              <div class="h-11 w-11 rounded-full overflow-hidden">
                <img class="rounded-full" :src="user.photo" alt="">
              </div>
              <div class="flex flex-col gap-0 justify-center col-span-4">
                <div class="overflow-hidden text-ellipsis whitespace-nowrap text-body_md_semibold">
                  {{ user.name }}
                </div>
                <div class="text-body_sm_regular">
                  {{ user.schoolName }}
                </div>
              </div>
            </div>
            <div class="flex sticky bottom-0 text-label_md_semibold text-primary cursor-pointer py-1.5 justify-center bg-background" @click="addAccount">{{ $t('Tambah akun') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import loading from '../icons/animation/loading.vue';

let brand = null

try {
  brand = require('@/brand-config.json');
} catch (e) {
  console.warn('brand-config.json not found, using general app settings')
}

const addAccount = () => {
  store.state.home.openSwitchAccountModal = true

  if (brand) {
    store.state.auth.switchAccountState = 'login'
  }
}

const store = useStore()
const users = computed( () => {
  const preferences = JSON.parse(localStorage.getItem('preferences')) || {};
  let allUsers = {
    current: [],
    all: []
  };
  if (preferences.schools && preferences.schools.length > 0) {
    preferences.schools.forEach(school => {
      if (school.users && school.users.length > 0) {
        school.users.forEach(user => {
          // console.log(user);
          if(user.isActive) {
            allUsers.current.push({
                schoolCode: school.code,
                schoolName: school.name,
                classroom: user.classroom,
                id: user.id,
                name: user.name,
                photo: user.photo ? getPhoto(user.photo) : 'https://ui-avatars.com/api/?name=' + encodeURIComponent(user.name) + '&background=818181&color=fff&size=72',
                isActive: user.isActive,
            });
          } else {
            allUsers.all.push({
                schoolCode: school.code,
                schoolName: school.name,
                classroom: user.classroom,
                id: user.id,
                name: user.name,
                photo: user.photo ? getPhoto(user.photo) : 'https://ui-avatars.com/api/?name=' + encodeURIComponent(user.name) + '&background=818181&color=fff&size=48',
                isActive: user.isActive,
            });
          }
        });
      }
    })
  }
  return allUsers;
})

function getPhoto (url) {
  if (url.startsWith("http")) {
    return url
  } else {
    return school.domain + url
  }
}

const logout = () => {
  store.state.isLoading = true
  store.dispatch('auth/logout')
}
</script>